export function Strong({ children }: { children: React.ReactNode }) {
	return <strong className="text-neutral-100">{children}</strong>
}
